export const setParams = ({ commit }, params) => {
  commit('setParams', params)
}



// WEBPACK FOOTER //
// ./src/store/actions.js